import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/llorentegerman/Documents/code/otros/react-collapsible-content/docz/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { Code } from 'gatsby-theme-docz/src/components/Code';
import { Column } from 'simple-flexbox';
import CollapsibleContent from 'react-collapsible-content';
import ToggleButtonComponent from './common/ToggleButtonComponent';
import DynamicText from './common/DynamicText';
import DynamicChildren from './common/DynamicChildren';
import CountdownComponent from './common/CountdownComponent';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "dynamic-content"
    }}>{`Dynamic Content`}</h1>
    <p>{`See how the component behaves when it has dynamic content.
In `}<a parentName="p" {...{
        "href": "/react-collapsible-content/comparisons"
      }}>{`comparisons`}</a>{` section you will see how other libraries reacts to the same content.`}</p>
    <p>{`See `}<a parentName="p" {...{
        "href": "#countdowncomponent"
      }}>{`CountdownComponent`}</a>{` and `}<a parentName="p" {...{
        "href": "#dynamicchildren"
      }}>{`DynamicChildren`}</a>{` definitions below.`}</p>
    <h2 {...{
      "id": "only-child"
    }}>{`Only child`}</h2>
    <p>{`See how the component reacts when the content of its only child changes.`}</p>
    <Playground __position={0} __code={'() => {\n  const [expanded, setExpanded] = React.useState(true)\n  return (\n    <Column>\n      <p>\n        Content will change in: <CountdownComponent delay={5000} /> seconds\n        (refresh to restart).\n      </p>\n      <Column style={{ maxWidth: 600, width: \'100%\' }}>\n        <ToggleButtonComponent\n          expanded={expanded}\n          onClick={() => setExpanded(prev => !prev)}\n        />\n        <CollapsibleContent expanded={expanded}>\n          <DynamicText delay={5000} />\n        </CollapsibleContent>\n      </Column>\n    </Column>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Code,
      Column,
      CollapsibleContent,
      ToggleButtonComponent,
      DynamicText,
      DynamicChildren,
      CountdownComponent,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    {() => {
        const [expanded, setExpanded] = React.useState(true);
        return <Column mdxType="Column">
                <p>
                    Content will change in: <CountdownComponent delay={5000} mdxType="CountdownComponent" />{' '}
                    seconds (refresh to restart).
                </p>
                <Column style={{
            maxWidth: 600,
            width: '100%'
          }} mdxType="Column">
                    <ToggleButtonComponent expanded={expanded} onClick={() => setExpanded(prev => !prev)} mdxType="ToggleButtonComponent" />
                    <CollapsibleContent expanded={expanded} mdxType="CollapsibleContent">
                        <DynamicText delay={5000} mdxType="DynamicText" />
                    </CollapsibleContent>
                </Column>
            </Column>;
      }}
    </Playground>
    <h2 {...{
      "id": "multiple-children"
    }}>{`Multiple children`}</h2>
    <p>{`See how the component reacts when new children are added.`}</p>
    <Playground __position={1} __code={'() => {\n  const [expanded, setExpanded] = React.useState(true)\n  return (\n    <Column>\n      <p>\n        Content will change in: <CountdownComponent delay={5000} /> seconds\n        (refresh to restart).\n      </p>\n      <Column style={{ maxWidth: 600, width: \'100%\' }}>\n        <ToggleButtonComponent\n          expanded={expanded}\n          onClick={() => setExpanded(prev => !prev)}\n        />\n        <CollapsibleContent expanded={expanded}>\n          <DynamicChildren init={3} end={10} delay={5000} />\n        </CollapsibleContent>\n      </Column>\n    </Column>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Code,
      Column,
      CollapsibleContent,
      ToggleButtonComponent,
      DynamicText,
      DynamicChildren,
      CountdownComponent,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    {() => {
        const [expanded, setExpanded] = React.useState(true);
        return <Column mdxType="Column">
                <p>
                    Content will change in: <CountdownComponent delay={5000} mdxType="CountdownComponent" />{' '}
                    seconds (refresh to restart).
                </p>
                <Column style={{
            maxWidth: 600,
            width: '100%'
          }} mdxType="Column">
                    <ToggleButtonComponent expanded={expanded} onClick={() => setExpanded(prev => !prev)} mdxType="ToggleButtonComponent" />
                    <CollapsibleContent expanded={expanded} mdxType="CollapsibleContent">
                        <DynamicChildren init={3} end={10} delay={5000} mdxType="DynamicChildren" />
                    </CollapsibleContent>
                </Column>
            </Column>;
      }}
    </Playground>
    <h2 {...{
      "id": "countdowncomponent"
    }}>{`CountdownComponent`}</h2>
    <Code className={'tsx'} mdxType="Code">
    {`
import React, { useEffect, useRef, useState } from 'react';
export default function CountdownComponent({ delay }) {
    const [counter, setCounter] = useState(delay / 1000);
    const intervalRef = useRef();
    useEffect(() => {
        let mounted = true;
        const endDate = new Date().getTime() + delay;
        intervalRef.current = setInterval(() => {
            let diff =
                (Date.parse(new Date(endDate)) - Date.parse(new Date())) / 1000;
            diff = Math.floor(diff);
            if (diff <= 0) {
                clearInterval(intervalRef.current);
            }
            setCounter(diff);
        }, 1000);
        setTimeout(() => {
            if (!mounted) {
                return;
            }
            clearInterval(intervalRef.current);
        }, delay);
        return () => {
            mounted = false;
            clearInterval(intervalRef.current);
        };
    }, [delay]);
    return <span>{counter}</span>;
}
 `}
    </Code>
    <h2 {...{
      "id": "dynamicchildren"
    }}>{`DynamicChildren`}</h2>
    <Code className={'tsx'} mdxType="Code">
    {`
import React, { useEffect, useState } from 'react';
const getArray = (count) => new Array(count).fill().map((_, i) => i + 1);
export default function DynamicChildren({ delay = 2000, init = 3, end = 5 }) {
    const [array, setArray] = useState(getArray(init));
    useEffect(() => {
        let mounted = true;
        setTimeout(() => {
            if (!mounted) {
                return;
            }
            setArray(getArray(end));
        }, delay);
        return () => {
            mounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [delay]);
    return (
        <React.Fragment>
            {array.map((i) => (
                <div
                    style={{ backgroundColor: '#2EBFA5', color: 'white' }}
                    key={i}
                >
                    {i}
                </div>
            ))}
        </React.Fragment>
    );
}
`}
    </Code>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      